import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateClipCropStatusRequest } from './update-clip-crop-status-request';
import type { IUpdateClipCropStatusResponse } from './update-clip-crop-status-response';
import { updateClipCropStatusResponseSchema } from './update-clip-crop-status-response';

export async function updateClipCropStatusApi({
  clipId,
  body,
}: IUpdateClipCropStatusRequest): Promise<IValidatedResponse<IUpdateClipCropStatusResponse>> {
  return putRequest<IUpdateClipCropStatusResponse>({
    path: `/sys/clips/${clipId}/crop-status`,
    body,
    schema: updateClipCropStatusResponseSchema,
  });
}
